'use client'

import { type JSX, createContext, useContext } from 'react'

import type { PageContextCustomOptions } from '@/shared/types/SectionContextOptions'

type PurchaseComponentContext = PageContextCustomOptions

const PurchaseComponentContext = createContext<PurchaseComponentContext>(
  {} as PurchaseComponentContext,
)

export type PurchaseComponentContextProviderProps = PurchaseComponentContext & {
  children: React.ReactNode
}

export const PurchaseComponentContextProvider = ({
  children,
  ...props
}: PurchaseComponentContextProviderProps): JSX.Element => {
  return (
    <PurchaseComponentContext.Provider value={props}>{children}</PurchaseComponentContext.Provider>
  )
}

/**
 * Returns the current purchase component context.
 * This context is used to provide information about the purchase flow variant.
 *
 * Currently used only for global movers.
 */
export const usePurchaseComponentContext = () => useContext(PurchaseComponentContext)
